// @ts-nocheck
/**
 * Buy Now Button Component
 * Adds product to cart if not already present, then opens address drawer
 */
class BuyNowButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.btnText = this.querySelector('.buy-now-text');
    this.btnLoading = this.querySelector('.buy-now-loading');
    this.variantId = this.dataset.variantId;
    this.productId = this.dataset.productId;
    
    this.button?.addEventListener('click', this.handleClick.bind(this));
  }
  
  async handleClick(e) {
    e.preventDefault();
    
    this.setLoading(true);
    
    try {
      // Check if product is already in cart
      const cart = await fetch('/cart.js').then(r => r.json());
      const isInCart = cart.items.some(item => 
        item.variant_id.toString() === this.variantId.toString()
      );
      
      if (!isInCart) {
        // Add to cart first
        const formData = new FormData();
        formData.append('id', this.variantId);
        formData.append('quantity', '1');
        
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        
        if (!response.ok) {
          throw new Error('Failed to add to cart');
        }
        
        // Dispatch cart update event
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { source: 'buy-now-button' }
        }));
      }
      
      // Open address drawer
      const addressDrawer = document.querySelector('#address-drawer');
      if (addressDrawer?.showDialog) {
        addressDrawer.showDialog();
      } else {
        const dialog = addressDrawer?.querySelector('dialog');
        dialog?.showModal?.();
      }
      
    } catch (error) {
      console.error('Buy now error:', error);
    } finally {
      this.setLoading(false);
    }
  }
  
  setLoading(loading) {
    if (loading) {
      this.btnText.style.display = 'none';
      this.btnLoading.style.display = 'flex';
      this.button.disabled = true;
    } else {
      this.btnText.style.display = '';
      this.btnLoading.style.display = 'none';
      this.button.disabled = false;
    }
  }
}

if (!customElements.get('buy-now-button')) {
  customElements.define('buy-now-button', BuyNowButton);
}
